module.exports = __webpack_public_path__ + "static/media/App-Installs.ba547180.jpg";